import { useMemo } from 'react'
import { Permission, useHasPermission } from 'use-towns-client'

export const useIsChannelPinnable = (
    spaceId: string | undefined,
    channelId: string,
    loggedInWalletAddress: string | undefined,
) => {
    const { hasPermission, isLoading } = useHasPermission({
        spaceId: spaceId,
        channelId: channelId,
        walletAddress: loggedInWalletAddress ?? '',
        permission: Permission.PinMessage,
    })

    const isChannelPinnable = isLoading ? undefined : hasPermission

    return useMemo(() => {
        return {
            isChannelPinnable,
        }
    }, [isChannelPinnable])
}
